import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteLayout } from "./components/layout/SiteLayout";
import { PageMeta } from "./components/shared/PageMeta";
// Homepage sections: imported and rendered in EXACT visual order (Magic-to-Bricks contract).
import { Hero } from "./components/sections/Hero";
import { TrustBar } from "./components/sections/TrustBar";
import { OwnerStory } from "./components/sections/OwnerStory";
import { Testimonials } from "./components/sections/Testimonials";
import { CtaBand } from "./components/sections/CtaBand";
import { BuildPathways } from "./components/sections/BuildPathways";
import { DesignDiscovery } from "./components/sections/DesignDiscovery";
import { RealProjects } from "./components/sections/RealProjects";
import { BuildingJourney } from "./components/sections/BuildingJourney";
import { InclusionsClarity } from "./components/sections/InclusionsClarity";
import { FaqSection } from "./components/sections/FaqSection";
import { PlanningGuide } from "./components/sections/PlanningGuide";
import { ConsultationSection } from "./components/sections/ConsultationSection";
// Interior pages
import { HomeDesigns } from "./pages/HomeDesigns";
import { DesignDetail } from "./pages/DesignDetail";
import { Projects } from "./pages/Projects";
import { About } from "./pages/About";
import { OurProcess } from "./pages/OurProcess";
import { Contact } from "./pages/Contact";
import { NotFound } from "./pages/NotFound";
type AppProps = {
  heroEmphasis?: "consultation-first" | "design-first";
  heroHeadline?: "as-our-own" | "owners-care" | "checked-every-stage";
  showAssistant?: boolean;
};
export function App({
  heroEmphasis = "consultation-first",
  heroHeadline = "as-our-own",
  showAssistant = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="nwc39wy9i3yd">
      <Routes data-id="element-1" data-mp="nur948fv0n11">
        <Route element={<SiteLayout showAssistant={showAssistant} data-id="element-3" data-mp="nxn5hsc273nd" />} data-id="element-2" data-mp="nvaq9mxor7e0">
          <Route index element={<>
                <PageMeta title="New & Custom Home Builders Perth | Oceanside Living" description="Owner-led Perth home builders. Six single-storey designs for 10m to 15m lots, custom homes, knock-down/rebuilds, rear blocks and developments. Fixed-price contracts. Book a consultation." data-id="element-5" data-mp="35yomiyqxk0x" />
                <Hero emphasis={heroEmphasis} headline={heroHeadline} data-id="element-6" data-mp="86499f6lm69i" />
                <TrustBar data-id="element-7" data-mp="3gkl6xsz04y2b" />
                <OwnerStory data-id="element-8" data-mp="3glwg68b7uy0t" />
                <Testimonials data-id="element-9" data-mp="3gj1w4hw47f7x" />
                <CtaBand data-id="element-10" data-mp="3bn2ys4st6mvd" />
                <BuildPathways data-id="element-11" data-mp="3bnuurgqbimm6" />
                <DesignDiscovery data-id="element-12" data-mp="3bkgss9lkgff9" />
                <RealProjects data-id="element-13" data-mp="3qbfwp7bgifsi" />
                <BuildingJourney data-id="element-14" data-mp="3qcr0h74wjnjm" />
                <InclusionsClarity data-id="element-15" data-mp="3qd0owqaatmn7" />
                <FaqSection data-id="element-16" data-mp="3lk7k62etyeb4" />
                <PlanningGuide data-id="element-17" data-mp="3liwge2ldx6k0" />
                {/* Advice preview omitted: no approved articles exist yet. */}
                <ConsultationSection data-id="element-18" data-mp="2xssh27f8bsyt" />
              </>} data-id="element-4" data-mp="stko65asom3b" />
          <Route path="home-designs" element={<HomeDesigns data-id="element-20" data-mp="2stzaz029v48o" />} data-id="element-19" data-mp="2svahh7n3qq3h" />
          <Route path="home-designs/:slug" element={<DesignDetail data-id="element-22" data-mp="18c6lbwc21eb7" />} data-id="element-21" data-mp="18d9de7l45msp" />
          <Route path="projects" element={<Projects data-id="element-24" data-mp="1d4recvn4zndo" />} data-id="element-23" data-mp="1d4hnl5u9pc6x" />
          <Route path="about" element={<About data-id="element-26" data-mp="1d6kkm9tu85l5" />} data-id="element-25" data-mp="1d59hmc87v1v3" />
          <Route path="our-process" element={<OurProcess data-id="element-28" data-mp="ygmtpm4ix1s9" />} data-id="element-27" data-mp="yfv916cgsogr" />
          <Route path="contact" element={<Contact data-id="element-30" data-mp="13eoecbhll95u" />} data-id="element-29" data-mp="yheq2z5y33jl" />
          <Route path="*" element={<NotFound data-id="element-32" data-mp="13fg61b82qmqu" />} data-id="element-31" data-mp="13dwt9ulmmttt" />
        </Route>
      </Routes>
    </BrowserRouter>;
}